// extracted by mini-css-extract-plugin
export default {"container":"styles_container__oeg1V","spin":"styles_spin__CmySI"};